export const validateField = (name, value,formData = {}) => {
  const errors = {};

  switch (name) {
    case 'emailOrMobile':
      if (!value) {
        errors[name] = 'Email or Mobile Number is required.';
      } else if (!/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(value) && !/^[6-9]\d{9}$/.test(value)) {
        // !/^\d{10}$/.test(value)
        errors[name] = 'Enter a valid email or mobile number.';
      }
      break;

    case 'password':
        if (!value) {
          errors[name] = 'Password is required.';
        } else if (value.length < 6) {
          errors[name] = 'Password must be at least 6 characters long.';
        } else if (!/[A-Z]/.test(value)) {  // At least one uppercase letter
          errors[name] = 'Password must contain at least one uppercase letter.';
        } else if (!/[a-z]/.test(value)) {  // At least one lowercase letter
          errors[name] = 'Password must contain at least one lowercase letter.';
        } else if (!/[0-9]/.test(value)) {  // At least one number
          errors[name] = 'Password must contain at least one number.';
        } else if (!/[!@#$%^&*(),.?":{}|<>]/.test(value)) {  // At least one special character
          errors[name] = 'Password must contain at least one special character.';
        }
        break;

    case 'confirmPassword':
          if (!value) {
            errors[name] = 'Confirm Password is required.';
          } else if (formData.password && formData.password !== value) {
            errors[name] = 'Passwords do not match.';
          }
          break;

    case 'firstName':
    case 'first_name':
    case 'lastName':
    case 'last_name':
      if (!value) {
        errors[name] = `${name.toLowerCase().includes('first') ? 'First' : 'Last'} name is required.`;
      }
      break;

    case 'email':
      if (!value) {
        errors[name] = 'Email is required.';
      } else if (!/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(value)) {
        errors[name] = 'Enter a valid email address.';
      }
      break;
    case 'email_id':
      if (!value) {
        errors[name] = 'Email is required.';
      } else if (!/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(value)) {
        errors[name] = 'Enter a valid email address.';
      }
      break;
    case 'mobile_number':
    case 'phone':
      if (!value) {
        errors[name] = 'Phone number is required.';
      } else if (!/^[6-9]\d{9}$/.test(value)) {
        errors[name] = 'Enter a valid phone number.';
      }
      break;

    
   

    case 'alternative_mobile_number':
      if (value && !/^[6-9]\d{9}$/.test(value)) {
        errors[name] = `${name.replace('_', ' ')} should be a valid 10-digit mobile number starting with 6, 7, 8, or 9.`;
      }
      break;

    
    case 'jci_membership_id':
            if (!value) {
              errors[name] = 'JCI Membership ID is required.';
            }
            break;

    case 'address':
      if (!value) {
        errors[name] = 'Address is required.';
      }
      break;
    case 'jci_membership_id':
    case 'membershipId':
      if (!value) {
        errors[name] = 'Membership ID is required.';
      }
      break;

    case 'confirmPassword':
      if (!value) {
        errors[name] = 'Confirm Password is required.';
      }
      break;

    case 'profession':
        if (!value) {
          errors[name] = 'Profession is required.';
        }
        break;

    case 'zone':
        if (value === 'lom_president' && !value) {
          errors[name] = 'Zone is required for Lom President.';
        }
        break;

    case 'lom':
        if (value === 'lom_president' && !value) {
          errors[name] = 'Lom is required for Lom President.';
        }
        break;

    case 'profession_id':
        if (!value) {
          errors[name] = 'Profession is required.';
        }
        break;
  
    case 'zone_id':
      if (!value) {
        errors[name] = 'Zone is required for Lom President.';
      }
      break;
  
    case 'lom_id':
      if (!value) {
          errors[name] = 'Lom is required for Lom President.';
      }
      break;

    default:
      break;
  }

  return errors;
};

export const validateForm = (formData, fields) => {
  let errors = {};
  fields.forEach((field) => {
    errors = { ...errors, ...validateField(field, formData[field]) };
  });
  return errors;
};


// Function to check if passwords match
export const validatePasswordMatch = (password, confirmPassword) => {
if (password !== confirmPassword) {
  return 'Passwords do not match';
}
return '';
};



// src/utils/validation.js
export const validateSignUpForm = (formData) => {
  const errors = {};
   

  // Validate Name
  if (!formData.name) {
    errors.name = "Name with Title is required.";
  }


  // Validate Membership ID
  if (!formData.membershipId) {
    errors.membershipId = "JCI Membership ID is required.";
  }

  // Validate Highest Portfolio in JCI
  if (!formData.highest_portfolio) {
    errors.highest_portfolio = "Highest Portfolio in JCI is required.";
  }

  // Validate Highest Position in Training
  if (!formData.highest_position_training) {
    errors.highest_position_training = "Highest Position in Training is required.";
  }

  // Validate Date of Birth
  if (!formData.dob) {
    errors.dob = "Date of Birth is required.";
  }

  // Validate Contact Number
  if (!formData.phone) {
    errors.phone = "Contact Number is required.";
  } else if (!/^[6-9]\d{9}$/.test(formData.phone)) {
    errors.phone = "Phone number must be 10 digits and start with 6, 7, 8, or 9.";
  }

  // Validate WhatsApp Number
  if (!formData.whatsapp_no) {
    errors.whatsapp_no = "WhatsApp Number is required.";
  } else if (!/^[6-9]\d{9}$/.test(formData.whatsapp_no)) {
    errors.whatsapp_no = "WhatsApp number must be 10 digits and start with 6, 7, 8, or 9.";
  }

  if (!formData.district) {
    errors.district = "District is required.";
  }

  if (!formData.trainerZoneXVIII) {
    errors.trainerZoneXVIII = "Trainer Zone selection is required.";
  }

  if (!formData.lomId) {
    errors.lomId = "Please select a LOM.";
  }

  return errors;
};




// src/utils/validation.js
export const validateEditZoneTrainerForm = (formData) => {
  const errors = {};
   

  // Validate Name
  if (!formData.name) {
    errors.name = "Name with Title is required.";
  }
    // Name Validation
    if (!formData.trainer_from_zone_18) {
      errors.name ="trainer is required.";
    }

  // Validate Membership ID
  if (!formData.membershipId) {
    errors.membershipId = "JCI Membership ID is required.";
  }

  // Validate Highest Portfolio in JCI
  if (!formData.highest_portfolio) {
    errors.highest_portfolio = "Highest Portfolio in JCI is required.";
  }

  // Validate Highest Position in Training
  if (!formData.highest_position_training) {
    errors.highest_position_training = "Highest Position in Training is required.";
  }

  // Validate Date of Birth
  if (!formData.dob) {
    errors.dob = "Date of Birth is required.";
  }

  if (!formData.whatsapp_number) {
    errors.whatsapp_number = "WhatsApp Number is required.";
  } else if (!/^[6-9]\d{9}$/.test(formData.whatsapp_number)) {
    errors.whatsapp_number = "WhatsApp number must be 10 digits and start with 6, 7, 8, or 9.";
  }

  if (!formData.contact_number) {
    errors.contact_number = "contact Number is required.";
  } else if (!/^[6-9]\d{9}$/.test(formData.whatsapp_number)) {
    errors.contact_number = "contact number must be 10 digits and start with 6, 7, 8, or 9.";
  }

  if (!formData.district_id) {
    errors.district_id = "District is required.";
  }

  if (!formData.trainer_from_zone_18) {
    errors.trainer_from_zone_18 = "Trainer Zone selection is required.";
  }

  if (!formData.lomId) {
    errors.lomId = "Please select a LOM.";
  }

  return errors;
};

// src/utils/validation.js
export const validateTrainerForm = (formData) => {
  const errors = {};
  console.log(formData);  
  
  // Validate Name
  if (formData.name ==="") {
    errors.name = "Name with Title is required.";
  }

  if (formData.lomId === "") {
    errors.lomId = "Lom Name is required.";
  }

    // Name Validation
    if (formData.trainer_from_zone_18 === "") {
      errors.name ="trainer is required.";
    }

  // Validate Membership ID
  if (formData.membershipId === "") {
    errors.membershipId = "JCI Membership ID is required.";
  }

  // Validate Highest Portfolio in JCI
  if (formData.highest_portfolio ==="") {
    errors.highest_portfolio = "Highest Portfolio in JCI is required.";
  }

  // Validate Highest Position in Training
  if (formData.highest_position_training === "") {
    errors.highest_position_training = "Highest Position in Training is required.";
  }


  if (!formData.whatsapp_number) {
    errors.whatsapp_number = "WhatsApp Number is required.";
  } else if (!/^[6-9]\d{9}$/.test(formData.whatsapp_number)) {
    errors.whatsapp_number = "WhatsApp number must be 10 digits and start with 6, 7, 8, or 9.";
  }

  if (!formData.contact_number) {
    errors.contact_number = "contact Number is required.";
  } else if (!/^[6-9]\d{9}$/.test(formData.contact_number)) {
    errors.contact_number = "contact number must be 10 digits and start with 6, 7, 8, or 9.";
  }

  return errors;
};

export const validateLomPresidentData = (formData) => {
  const errors = {};
  
  // Name Validation
  if (!formData.name) {
    errors.name = "Name is required.";
  }
  
  // Member ID Validation
  if (!formData.membershipId) {
    errors.membershipId = "Member ID is required.";
  }
  
  // Contact Number Validation (Starts with 6, 7, 8, or 9 and 10 digits long)
  const phoneRegex = /^[6-9][0-9]{9}$/;
  if (!formData.contactNumber || !phoneRegex.test(formData.contactNumber)) {
    errors.contactNumber = "Please enter a valid 10-digit contact number starting with 6, 7, 8, or 9.";
  }
 

  // if(formData.isTrainer === "true" || formData.isTrainer === true)
  //   {
  //       if (!formData.whatsapp_number || !phoneRegex.test(formData.whatsapp_number)) {
  //         errors.whatsapp_number = "Please enter a valid 10-digit whatsapp_no number starting with 6, 7, 8, or 9.";
  //       }
  //   }

  
  
  if (!formData.whatsapp_number || !phoneRegex.test(formData.whatsapp_number)) {
      errors.whatsapp_number = "Please enter a valid 10-digit whatsapp_no number starting with 6, 7, 8, or 9.";
  }
    


  // Address Validation
  if (!formData.address) {
    errors.address = "Address is required.";
  }
  
  // Social Media URL Validation (Basic URL check)
  const urlRegex = /^(https?|chrome):\/\/[^\s$.?#].[^\s]*$/;
  if (formData.facebook && !urlRegex.test(formData.facebook)) {
    errors.facebook = "Please enter a valid Facebook URL.";
  }
  if (formData.instagram && !urlRegex.test(formData.instagram)) {
    errors.instagram = "Please enter a valid Instagram URL.";
  }
  if (formData.youtube && !urlRegex.test(formData.youtube)) {
    errors.youtube = "Please enter a valid YouTube URL.";
  }
  if (formData.linkedIn && !urlRegex.test(formData.linkedIn)) {
    errors.linkedIn = "Please enter a valid LinkedIn URL.";
  }
  
  return errors;
};


export const validateLomPresidentAddData = (formData) => {
  const errors = {};
  
  // Name Validation
  if (!formData.name) {
    errors.name = "Name is required.";
  }
  
  // Member ID Validation
  if (!formData.membershipId) {
    errors.membershipId = "Member ID is required.";
  }
  
  // Contact Number Validation (Starts with 6, 7, 8, or 9 and 10 digits long)
  const phoneRegex = /^[6-9][0-9]{9}$/;
  if (!formData.contactNumber || !phoneRegex.test(formData.contactNumber)) {
    errors.contactNumber = "Please enter a valid 10-digit contact number starting with 6, 7, 8, or 9.";
  }
 
  // if(formData.isTrainer === "true" || formData.isTrainer === true)
  // {
  //     if (!formData.whatsapp_no || !phoneRegex.test(formData.whatsapp_no)) {
  //       errors.whatsapp_no = "Please enter a valid 10-digit whatsapp_no number starting with 6, 7, 8, or 9.";
  //     }
  // }
  

    
  if (!formData.whatsapp_no || !phoneRegex.test(formData.whatsapp_no)) {
      errors.whatsapp_no = "Please enter a valid 10-digit whatsapp_no number starting with 6, 7, 8, or 9.";
  }

  // Address Validation
  if (!formData.address) {
    errors.address = "Address is required.";
  }
  
  // Social Media URL Validation (Basic URL check)
  const urlRegex = /^(https?|chrome):\/\/[^\s$.?#].[^\s]*$/;
  if (formData.facebook && !urlRegex.test(formData.facebook)) {
    errors.facebook = "Please enter a valid Facebook URL.";
  }
  if (formData.instagram && !urlRegex.test(formData.instagram)) {
    errors.instagram = "Please enter a valid Instagram URL.";
  }
  if (formData.youtube && !urlRegex.test(formData.youtube)) {
    errors.youtube = "Please enter a valid YouTube URL.";
  }
  if (formData.linkedIn && !urlRegex.test(formData.linkedIn)) {
    errors.linkedIn = "Please enter a valid LinkedIn URL.";
  }
  
  return errors;
};
